import React from 'react';
import { Spinner } from 'reactstrap';

const Loading = () => (
  <div className="text-center">
    <Spinner />
  </div>
);
export default Loading;
